import { useSelector } from 'react-redux';
import { filteredCruisePackagesCountSelector } from '../../redux/selectors/cruiseList/filterSelectors';
import { selectLabels, selectNumberOfCruises } from '../../redux/selectors/cruiseList';
import './cruiseListHits.scss';

// Reads state through hooks, so it takes no props and needs no propTypes.
const CruiseListHits = () => {
  const labels = useSelector(selectLabels);
  const numberOfCruises = useSelector(selectNumberOfCruises);
  const numberOfFilteredCruises = useSelector(filteredCruisePackagesCountSelector);

  const getNumberOfCruisesLabel = () => {
    let numberOfCruisesLabel = '';

    if (numberOfFilteredCruises === numberOfCruises) {
      numberOfCruisesLabel = labels.cruiseCountLabel.replace('{numberOfCruises}', numberOfCruises);
    } else {
      numberOfCruisesLabel = labels.filteredCruiseCountLabel
        .replace('{matches}', numberOfFilteredCruises)
        .replace('{total}', numberOfCruises);
    }

    return numberOfCruisesLabel;
  };

  return <div className="iw-cruise-list-hits">{getNumberOfCruisesLabel()}</div>;
};

export default CruiseListHits;
